/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Channelreplyplaceholder2Inputs */

const en_channelreplyplaceholder2 = /** @type {(inputs: Channelreplyplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reply as Pulsify...`)
};

const de_channelreplyplaceholder2 = /** @type {(inputs: Channelreplyplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Als Pulsify antworten…`)
};

/**
* | output |
* | --- |
* | "Reply as Pulsify..." |
*
* @param {Channelreplyplaceholder2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const channelreplyplaceholder2 = /** @type {((inputs?: Channelreplyplaceholder2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Channelreplyplaceholder2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_channelreplyplaceholder2(inputs)
	return de_channelreplyplaceholder2(inputs)
});
export { channelreplyplaceholder2 as "channelReplyPlaceholder" }